import { HourCodeService, IHourCode } from "../../../services/hourCode.service";
import { SalaryScaleGroupService, ISalaryScaleGroup } from "../../../services/salaryScaleGroup.service";

interface IResolve {
    hourCode: IHourCode;
}

class HourCodesItemBasicController {

    private resolve: IResolve;
    private hourCode: IHourCode;
    salaryScaleGroups: ISalaryScaleGroup[] = [];
    private close: any;
    typeSelect: string; // String value for AngularJS select

    constructor(
        private HourCodeService: HourCodeService,
        private SalaryScaleGroupService: SalaryScaleGroupService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private $timeout: ng.ITimeoutService,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    public $onInit = () => {        
        if (this.resolve.hourCode) {
            this.hourCode = this.resolve.hourCode;
            // Convert type to string for AngularJS select
            if (this.hourCode.type !== undefined && this.hourCode.type !== null) {
                this.typeSelect = String(this.hourCode.type);
            } else {
                this.typeSelect = '0'; // Default to Looncomponent
                this.hourCode.type = 0;
            }
        } else {
            // Get caoId from state params if available (for new hourcodes)
            const caoId = this.$stateParams['caoId'];
            this.hourCode = {
                code: '',
                name: '',
                description: '',
                twinfieldCode: '',
                value: null,
                value2: null,
                salaryScaleGroupId: caoId || null,
                type: 0, // Default: Looncomponent
            } as any as IHourCode;
            this.typeSelect = '0'; // Default for select
        }

        // Load salary scale groups
        this.SalaryScaleGroupService.all().then((result: ISalaryScaleGroup[]) => {
            // Sort alphabetically by name
            this.salaryScaleGroups = result.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
            
            // Trigger chosen update after data is loaded
            this.$timeout(() => {
                if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                    (<any>window).jQuery('select[name="salaryScaleGroup"]').trigger('chosen:updated');
                }
            }, 0);
        });
    }

    submitHourCode() {
        // Convert typeSelect string to number before submitting
        this.hourCode.type = parseInt(this.typeSelect, 10);
        
        if (this.hourCode.id === undefined) {
            this.HourCodeService.post(this.hourCode).then((result: any) => {
                // Preserve selected CAO when navigating back
                const selectedCaoId = this.hourCode.salaryScaleGroupId || this.$stateParams['caoId'];
                this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId }, {reload: true});
            });
        } else {
            this.HourCodeService.put(this.hourCode.id, this.hourCode).then(result => {
                // Preserve selected CAO when navigating back
                const selectedCaoId = this.hourCode.salaryScaleGroupId;
                this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId }, {reload: true});
            });
        }
    }

    deleteHourCode() {
        this.SweetAlert.swal({
            title: 'Weet je het zeker?',
            text: "Je kunt dit niet ongedaan maken!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja, verwijderen!',
            cancelButtonText: 'Nee, annuleren!',
        }, (isConfirm) => {
            if (isConfirm) {
                this.HourCodeService.delete(this.hourCode.id).then(() => {
                    const selectedCaoId = this.hourCode.salaryScaleGroupId;
                    this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId }, {reload: true});
                });
            }
        });
    }

    public closeModal = () => {
        // Preserve selected CAO when closing modal
        const selectedCaoId = this.hourCode.salaryScaleGroupId || this.$stateParams['caoId'];
        
        // Navigate back to list with selected CAO preserved
        this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId || null }, { reload: false });
    }
}

export const hourCodesItemBasicComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: HourCodesItemBasicController,
    template: require('./hourCodes.item.basic.html')
};




// WEBPACK FOOTER //
// ./src/app/modules/settings/hourCodes/hourCodes.item.basic.component.ts